var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPackageLeftIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "previous 1",
    clipPath: "url(#clip0_275_235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5 0C8.73067 0 0 8.73067 0 19.5C0 30.2693 8.73067 39 19.5 39C30.2693 39 39 30.2693 39 19.5C39 8.73067 30.2693 0 19.5 0ZM19.5 35.75C10.5256 35.75 3.25003 28.4744 3.25003 19.5C3.25003 10.5256 10.5256 3.25003 19.5 3.25003C28.4744 3.25003 35.75 10.5256 35.75 19.5C35.75 28.4744 28.4744 35.75 19.5 35.75Z",
    fill: "#3D8CCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.8991 10.2259C23.2645 9.59135 22.2356 9.59135 21.601 10.2259L13.4759 18.351C12.8414 18.9856 12.8414 20.0145 13.4759 20.6491L21.601 28.7741C22.2356 29.4087 23.2645 29.4087 23.8991 28.7741C24.5337 28.1395 24.5337 27.1106 23.8991 26.476L16.9231 19.5L23.8991 12.524C24.5337 11.8895 24.5337 10.8606 23.8991 10.2259Z",
    fill: "#3D8CCC"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_275_235",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageLeftIcon);
export default __webpack_public_path__ + "static/media/package_left-icon.779b63c2c3a25c46da76f1dcaaab5b0e.svg";
export { ForwardRef as ReactComponent };